import keyMirror from 'keymirror';

export const ACTIONS = keyMirror({
  ADD_WPAPI_KEY: null,
  SET_AVAILABLE_LANGUAGES: null,
  LOCATION_CHANGE: null,
  SET_RESOLVE_PATH: null,
  OPEN_SEARCH: null,
  SET_SEARCH_RESULT: null,
  SET_CLOSE_NAVBAR: null,
  SEARCH_LOADING: null,
  SET_SEARCH_STRING: null,
  UPDATE_SEARCH_PARAMS: null,
  SET_DOWNLOAD_ITEM_ACTIVE: null
});



// WEBPACK FOOTER //
// ./src/redux/action/actionTypes.js